import { Stack, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { Alert } from 'ComponentLibrary'

export type UploadErrorAlertCopy = {
    title: string
    description: string
    supportText: string
}

const DEFAULT_UPLOAD_ERROR_ALERT_COPY: UploadErrorAlertCopy = {
    title: 'Fehler beim Hochladen der Dateien',
    description: 'Folgende Dateien konnten nicht erfolgreich hochgeladen werden:',
    supportText: 'Bitte versuchen Sie es erneut oder schreiben Sie eine Nachricht an support@einwert.com',
}

export const UploadErrorAlert = ({ failedUploads, copy }: { failedUploads: string[]; copy?: Partial<UploadErrorAlertCopy> }) => {
    const theme = useTheme()
    const [hideError, setHideError] = useState(false)
    const resolvedCopy = { ...DEFAULT_UPLOAD_ERROR_ALERT_COPY, ...copy }

    useEffect(() => {
        setHideError(false)
    }, [failedUploads])

    if (hideError) {
        return null
    }

    return (
        <Alert severity="error" size="small" title={resolvedCopy.title} onClose={() => setHideError(true)}>
            <Stack direction="column" gap={theme.spacing(1)}>
                <Typography variant="bodyTextSmall" color={theme.palette.error.main}>
                    {resolvedCopy.description}
                </Typography>
                {failedUploads.map((name, index) => {
                    return (
                        <Typography key={`Failed-upload-${index}-${name}`} variant="bodyTextSmall" color={theme.palette.error.main}>
                            - <b>{name}</b>
                        </Typography>
                    )
                })}
                <Typography variant="bodyTextSmall" color={theme.palette.error.main}>
                    {resolvedCopy.supportText}
                </Typography>
            </Stack>
        </Alert>
    )
}
